import React, { PureComponent, useState } from "react";
import logo from "../shadow-logo.png";
import street from "../street-view.png";
import { navigate } from "@reach/router";

const Post = (props) => {
  const visit = () => {
    console.log(props.loc);
    navigate(`/hall/${props.loc.hall}`, {
      state: { x_init: props.loc.x, y_init: props.loc.y, z_init: props.loc.z },
    });
  };

  const canReply = Boolean(props.currentUserId);
  const canEdit = props.currentUserId === props.post.userId;
  const canDelete = props.currentUserId === props.post.userId;
  const [wantToEdit, setWantToEdit] = useState(false);
  const [newText, setNewText] = useState("");
  const createdAt = new Date(props.post.createdAt).toLocaleDateString();
  return (
    <div className="border border-slate-500/50 flex flex-col drop-shadow-2xl shadow-black m-4 rounded-3xl bg-slate-700 text-white">
      <div className="flex flex-row justify-between border-b border-slate-500/50 bg-slate-600 rounded-t-3xl">
        <div className="flex flex-row py-2">
          <div className="flex-none mx-3">
            <img
              className="h-12 w-12 rounded-full"
              src={props.pfp ? props.pfp : logo}
            ></img>
          </div>
          <div className="my-auto">
            <div className="text-sm font-bold align-bottom">
              {props.post.username}
            </div>
            <div className="text-xs text-gray-400">Posted on {createdAt}</div>
          </div>
        </div>
        {props.loc && <img
          onClick={visit}
          className="h-12 w-12 mx-3 my-2 hover:border-2 hover:cursor-pointer hover:border-opacity-0 hover:border-slate-400 hover:rounded-xl"
          src={street}
        ></img>}
      </div>

      <div class="flex-grow">
        <div className="post-text my-4 text-center text-2xl break-words py-1 px-2">
          {wantToEdit ? (
            <textarea
              onChange={(e) => setNewText(e.target.value)}
              className="border p-1 border-slate-600 bg-transparent w-10/12"
            >
              {props.post.body}
            </textarea>
          ) : (
            props.post.body
          )}
        </div>
      </div>

      <div class="flex flex-row p-1">
        {/* {canReply && !wantToEdit && (
          <div className="flex-grow font-bold rounded-full m-1 py-2 text-center cursor-pointer shadow-lg text-gray-200 bg-black bg-opacity-75 hover:bg-opacity-50">
            Reply
          </div>
        )} */}
        {canEdit && (
          <div
            className="flex-grow font-bold rounded-full m-1 py-2 text-center cursor-pointer shadow-lg text-gray-200 bg-black bg-opacity-75 hover:bg-opacity-50"
            onClick={() => {
              setWantToEdit(!wantToEdit);
              setNewText(props.post.body);
            }}
          >
            {wantToEdit ? "Cancel" : "Edit"}
          </div>
        )}
        {canDelete && !wantToEdit && (
          <div
            className="flex-grow font-bold rounded-full m-1 py-2 text-center cursor-pointer shadow-lg text-gray-200 bg-red-700 bg-opacity-70 hover:bg-opacity-50"
            onClick={() => props.deletePost(props.post._id, newText)}
          >
            Delete
          </div>
        )}
        {wantToEdit && (
          <button
            disabled={newText === props.post.body}
            className="flex-grow font-bold rounded-full m-1 py-2 text-center cursor-pointer shadow-lg text-gray-200 bg-black bg-opacity-75 hover:bg-opacity-50"
            onClick={() => {
              props.editPost(props.post._id, newText);
              setNewText("");
              setWantToEdit(!wantToEdit);
            }}
          >
            Submit
          </button>
        )}
      </div>

      {/* 
        <!-- probably should check if this still displays correctly (note: probably wont) =->
        {!!props.replies.length && (
          <div className="replies">
            {props.replies.map((reply) => (
              <Post
                key={reply._id}
                post={reply}
                replies={[]}
                currentUserId={props.currentUserId}
                deletePost={props.deletePost}
              />
            ))}
          </div>
        )} */}
    </div>
  );
};

export default Post;
